import godsViewMap from "./godsViewMap.component";

const godsViewMapModule = angular
  .module("app.components.godsViewMap", [])
  .component("godsViewMap", godsViewMap);

export default godsViewMapModule;



// WEBPACK FOOTER //
// ./src/components/godsViewMap/godsViewMap.module.js